import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import { normalizeAppLocale, applyDocumentLanguage } from './languages';
import { ensureLocaleLoaded } from './loadLocale';

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
  },
  lng: 'en',
  fallbackLng: 'en',
  supportedLngs: ['en', 'es', 'fr', 'de', 'pt', 'zh', 'ja', 'hi', 'ar'],
  nonExplicitSupportedLngs: true,
  returnEmptyString: false,
  interpolation: { escapeValue: false },
  // Avoid re-rendering the whole tree on minor i18n internal updates
  react: { useSuspense: false },
});

const stored = normalizeAppLocale(
  typeof localStorage !== 'undefined' ? localStorage.getItem('co_taskr_locale') : 'en',
);

if (stored !== 'en') {
  void ensureLocaleLoaded(stored).then((code) => {
    if (i18n.language !== code) void i18n.changeLanguage(code);
    applyDocumentLanguage(code);
  });
} else {
  applyDocumentLanguage('en');
}

export { applyDocumentLanguage, ensureLocaleLoaded };
export default i18n;
